import React from 'react';
import { Box, Chip, Stack, Typography, alpha } from '@mui/material';

export default function SectionHeader({ accentColor, title, count }) {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
      <Box sx={{ width: 4, height: 18, borderRadius: 1, bgcolor: accentColor }} />
      <Typography variant="subtitle1" fontWeight={700}>{title}</Typography>
      <Chip size="small" label={`${count} คน`} sx={{ bgcolor: alpha(accentColor, 0.12), color: accentColor, fontWeight: 600 }} />
    </Stack>
  );
}
